import { storeActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'
import { Button } from '@repo/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@repo/ui/dropdownMenu'
import { useT } from '@repo/ui/hooks'
import { Language } from '@repo/ui/lang'
import { Globe, MenuIcon } from 'lucide-react'
import { ReactNode, useState } from 'react'

export function Menu({
  children,
  trigger,
}: {
  children?: ReactNode
  trigger?: ReactNode
}) {
  const dispatch = useStoreDispatch()
  const { setLanguage } = useT()
  const [open, setOpen] = useState(false)
  return (
    <DropdownMenu onOpenChange={setOpen} open={open} defaultOpen={open}>
      <DropdownMenuTrigger asChild>
        {trigger ? (
          trigger
        ) : (
          <Button
            size="icon"
            variant="outline"
            className="data-[state=open]:bg-primary data-[state=open]:text-white"
          >
            <MenuIcon className="size-4" />
          </Button>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="rounded-md"
        side="bottom"
        align="start"
        sideOffset={4}
      >
        <DropdownMenuGroup>
          {children}
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => {
              setLanguage(
                Language.FR,
                (language) =>
                  void dispatch(
                    storeActions.updateBeneficiaryLanguage({ language }),
                  ),
              )
            }}
          >
            <Globe className="size-4" />
            Passer en français
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              setLanguage(
                Language.EN,
                (language) =>
                  void dispatch(
                    storeActions.updateBeneficiaryLanguage({ language }),
                  ),
              )
            }}
          >
            <Globe className="size-4" />
            Switch to English
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              setLanguage(
                Language.ES,
                (language) =>
                  void dispatch(
                    storeActions.updateBeneficiaryLanguage({ language }),
                  ),
              )
            }}
          >
            <Globe className="size-4" />
            Pasar al español
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              setLanguage(
                Language.PT,
                (language) =>
                  void dispatch(
                    storeActions.updateBeneficiaryLanguage({ language }),
                  ),
              )
            }}
          >
            <Globe className="size-4" />
            Pasar al portugués
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
